import React from "react";
import Seo, { breadcrumbSchema } from "@/components/Seo";
import PageHero from "@/components/PageHero";
import MapEmbed from "@/components/MapEmbed";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";
import { SectionHeading } from "@/components/ui-bits";
import { ATTRACTIONS, NEARBY, IMAGES } from "@/lib/site";

export default function Attractions() {
  return (
    <>
      <Seo
        title="Attractions Near Pittsburg, KS | Local Guide — Regency Inn & Suites"
        description="Discover attractions near Regency Inn & Suites in Pittsburg, Kansas — Pittsburg State University, Lincoln Park, Big Brutus, famous fried chicken, museums, golf and more."
        path="/attractions"
        image={IMAGES.landscape}
        schema={[breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Attractions", path: "/attractions" }])]}
      />
      <PageHero
        eyebrow="Explore Pittsburg"
        title="Everything worth seeing, close by."
        subtitle="From campus and coal-country landmarks to the legendary fried-chicken houses, the best of southeast Kansas is minutes from your room."
        image={IMAGES.landscape}
        crumbs={[{ name: "Home", path: "/" }, { name: "Attractions", path: "/attractions" }]}
      />

      <section className="bg-bone py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <Stagger className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {ATTRACTIONS.map((a) => (
              <StaggerItem key={a.name}>
                <article className="group h-full flex flex-col" data-testid={`attraction-${a.name.split(" ")[0]}`}>
                  <div className="img-zoom aspect-[4/3] rounded-md">
                    <img src={a.img} alt={a.name} className="w-full h-full object-cover" loading="lazy" />
                  </div>
                  <div className="mt-4 flex items-center justify-between">
                    <span className="text-xs uppercase tracking-widest text-amber-deep">{a.cat}</span>
                    <span className="text-xs text-stone">{a.dist} away</span>
                  </div>
                  <h2 className="font-serif text-2xl text-forest mt-2">{a.name}</h2>
                  <p className="text-stone mt-2 leading-relaxed text-[15px]">{a.copy}</p>
                </article>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>

      <section className="bg-sand py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-2 gap-14 items-center">
          <Reveal>
            <SectionHeading eyebrow="Local SEO" title="Serving all of southeast Kansas." />
            <p className="mt-6 text-stone leading-relaxed">
              Our central location off US Highway 69 makes us a convenient base for travelers across the region.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              {NEARBY.map((n) => (
                <span key={n} className="rounded-full border border-forest/20 bg-bone px-5 py-2.5 text-sm text-forest">
                  {n}
                </span>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <MapEmbed height="420px" />
          </Reveal>
        </div>
      </section>
    </>
  );
}
